import { skipToken, useQuery } from "@tanstack/react-query";
import api from "../../../../../api";
import urls from "../../../../../urls";
import type { EdaFilter } from "../../EnergyDataAcquisitionSelectionModal/EnergyDataAcquisitionSelectionModal";
import type { AcquisitionFilter } from "../../EnergyDataView";

export type EnergyDataAcquisitionFilters = Array<
  EdaFilter & { appliedFilters: AcquisitionFilter[] }
>;

export function useEnergyDataAcquisitionFilters(projectId?: string) {
  return useQuery({
    queryKey: ["definedFilters", { projectId }],
    queryFn: projectId
      ? () => fetchEnergyDataAcquisitionFilters(projectId)
      : skipToken
  });
}

async function fetchEnergyDataAcquisitionFilters(projectId: string) {
  const response = await api.get<EnergyDataAcquisitionFilters>(
    urls.api.energyDataAcquisitionFilters(projectId)
  );
  return response.data;
}
